<template>
  <div v-if="showAlert" class="error-text">
    <ul
      v-for="(error, index) in errorStatements"
      :key="index"
      class="mb-0"
      :class="{
        'list-unstyled': errorStatements.length === 1,
        multiline: errorStatements.length > 1,
      }"
    >
      <li>{{ error }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ErrorAlert',

  props: {
    errors: {
      type: Object,
      required: true,
    },
  },

  computed: {
    errorStatements() {
      let errors = [];
      const errorKeys = Object.keys(this.errors);

      for (let i = 0; i < errorKeys.length; i += 1) {
        errors = errors.concat(this.errors[errorKeys[i]]);
      }

      return errors;
    },
    showAlert() {
      return Object.keys(this.errors).length;
    },
  },
};
</script>
